import { SourceValue, CoOccupantInfo } from "../../types/contract";

// 型ガード関数
export const isSourceValue = (value: any): value is SourceValue => {
  return (
    value &&
    typeof value === "object" &&
    "value" in value &&
    "source_document" in value
  );
};

export const isCoOccupantInfo = (value: any): value is CoOccupantInfo => {
  return (
    value &&
    typeof value === "object" &&
    "value" in value &&
    Array.isArray(value.value)
  );
};